<template>
  <base-dialog show-close :visible.sync="visible">
    <template v-slot:header>删除应用模板</template>
    <div style="margin: 20px 0 10px 0; color:#606266">
      注意：应用权限为限制的模板，删除时将自动转为开放，且不可恢复，
    </div>
    <div style="margin-bottom: 10px; color:#606266">
      请输入模板名称 “
      <span style="color: red">{{ app.name }}</span>
      ”，表示您确认删除模板
    </div>
    <el-form :model="deleteInfo" status-icon :rules="rules" ref="deleteInfo" label-width="0">
      <el-form-item prop="appName">
        <el-input v-model="deleteInfo.appName"></el-input>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="deleteTempate">确定</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import * as appApi from "@/api/userCenter/app"
import { deepClone } from "@/utils/common"
export default {
  name: "delete-template-dialog",
  components: { BaseDialog, BaseButton },
  data() {
    let validateAppName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入应用名称"))
      } else if (this.deleteInfo.appName !== this.app.name) {
        callback(new Error('请输入应用名称 "' + this.app.name + '"'))
      } else {
        callback()
      }
    }
    return {
      visible: false,
      deleteInfo: {
        appName: ""
      },
      app: {},
      rules: {
        appName: [{ validator: validateAppName, trigger: "blur" }]
      }
    }
  },
  methods: {
    init(app) {
      this.app = deepClone(app)
      this.deleteInfo.appName = ""
      if (this.$refs.deleteInfo) this.$refs.deleteInfo.resetFields()
      this.visible = true
    },
    deleteTempate() {
      this.$refs.deleteInfo.validate(valid => {
        if (!valid) return
        appApi.deleteApp(this.app.id, true).then(res => {
          this.visible = false
          this.$emit("refresh")
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.delete-template-dialog {
  ::v-deep .el-dialog__body {
    padding-bottom: 15px !important;
  }
  .txt {
    margin-top: 15px;
    color: #606266;
  }
}
</style>
